import { render } from "./PageScrollerNavigation.vue?vue&type=template&id=2bac7dba"
import script from "./PageScrollerNavigation.vue?vue&type=script&lang=js"
export * from "./PageScrollerNavigation.vue?vue&type=script&lang=js"

import "./PageScrollerNavigation.vue?vue&type=style&index=0&id=2bac7dba&lang=scss"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__